import { Navigate } from 'react-router-dom'
import ManageLayout from '../layouts/Manage'
import Schemas from '../pages/manage/Schemas'
import {SchemaView, Loader as SchemaLoader} from '../pages/manage/SchemaView'
import Upload from '../pages/manage/upload'
import Wrangler from '../pages/manage/Wrangler'
import SchemaViewer from '../pages/manage/SchemaViewer'
import AccessControlLayout from '../layouts/AccessControlLayout'
import ErrorPage from '../pages/ErrorPage'
import StainSetup from '../pages/manage/StainSetup'
import RegionSetup from '../pages/manage/RegionSetup'
import BlockSetup from '../pages/manage/BlockSetup'
import { CaseBuilder, CaseBuilderLoader } from '../pages/manage/casebuilder/index'
import DataManagerRoadmap from '../pages/manage/DataManagerRoadmap'
import PathPresenterImportPage from '../pages/manage/PathPresenterImportPage'
import {
    CASEBUILDER_BASE,
    STAIN_SETUP_ROUTE,
    REGION_SETUP_ROUTE,
    BLOCK_SETUP_ROUTE,
    IMPORT_ROUTE,
    DATA_MANAGER_HOME,
} from '../constants/setupRoadmapSteps'

const ManageRoutes = {
    element: <AccessControlLayout requireDataManagerOrAdmin={true} useBaseLayout={true}/>,
    errorElement: <ErrorPage/>,
    children:[{
        element:<ManageLayout/>,
        children:[
            {
                path: '/manage',
                element: <Navigate to={DATA_MANAGER_HOME} replace />,
            },
            {
                path: DATA_MANAGER_HOME,
                element: <DataManagerRoadmap/>,
            },
            {
                path: STAIN_SETUP_ROUTE,
                element: <StainSetup/>,
            },
            {
                path: REGION_SETUP_ROUTE,
                element: <RegionSetup/>,
            },
            {
                path: BLOCK_SETUP_ROUTE,
                element: <BlockSetup/>,
            },
            {
                path: IMPORT_ROUTE,
                element: <PathPresenterImportPage/>,
            },
            {
                path: `${CASEBUILDER_BASE}/:name?`,
                element: <CaseBuilder/>,
                loader: CaseBuilderLoader,
            },
            {
                element: <AccessControlLayout isAdmin={true} useBaseLayout={false}/>,
                children: [
                    {
                        path: '/manage/schema',
                        element: <Schemas/>,
                    },
                    {
                        path: '/manage/schema/:name',
                        element: <SchemaView/>,
                        loader: SchemaLoader
                    },
                    {
                        path: '/manage/upload',
                        element: <Upload/>,
                    },
                    {
                        path: '/manage/wrangler',
                        element: <Wrangler/>
                    },
                    {
                        path: '/manage/schema-viewer',
                        element: <SchemaViewer/>
                    },
                ],
            },
        ]
    }],
}

export default ManageRoutes;
